<template>
    <div class="popup">
        <div class="parkContainer">
            <div class="dataContainer">
                <div class="title">
                    <div class="icon" @click="close"></div>
                    <div class="icright">
                        <div class="name">{{title.projectName}}</div>
                        <div class="area">{{title.projectArea}}㎡</div>
                    </div>
                </div>
                <div class="address">地址: {{title.projectAddress}}</div>
                <div class="dataItemContainer">
                    <div class="dataItem">
                        <div class="data_title">年用电量</div>
                        <div class="data_value">{{power}}<span>kWh</span></div>
                    </div>
                    <div class="dataItem">
                        <div class="data_title">楼宇数量</div>
                        <div class="data_value">{{buildnum}}</div>
                    </div>
                    <div class="dataItem">
                        <div class="data_title">网关在线</div>
                        <div class="data_value">--<span>/--</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import store from '../../../store/index' 
import { getTodayTime } from '../../../utils/common/index'
export default {
    props:['title'],
    data(){
        return {
            power:0,
            buildnum:0
        }
    },
    mounted(){
        // console.log(this.title);
        // console.log(Vue.prototype.$http);
        // console.log(store);
        this.getProjectPower()
        this.getBuilds()
    },
    methods:{
        close(){
            if(this.closeWin){
                this.closeWin()
            }
        },
        // 获取年用电
        async getProjectPower(){
            let time = getTodayTime()
            let year = new Date().getFullYear()
            let data = {
                start:`${year}-01-01T00:00:00Z`,
                end:`${time}T00:00:00Z`,
                projectId:store.state.projectId
            }
            let res = await Vue.prototype.$http.getPowerOut(data)
            this.power = Number(res.data.data.total).toFixed(0)
        },
        // 获取楼宇数量
        async getBuilds(){
            let data = {
                projectId:store.state.projectId
            }
            let res = await Vue.prototype.$http.getBuildCount(data)
            this.buildnum = res.data.data.tree
        }
    }
}
</script>

<style lang="less" scoped>
.popup{
    position: fixed;
    bottom:50vh ;
    left: 45vw;
    z-index: 1;
    .parkContainer {
        width:21.3vw ;    
        height: 260px;
        height: 26vh;
        background-image: url('../../../assets/img/yuanqupai.png');
        background-size: 100% 100%;

        .dataContainer {
            width: 18vw;
            position: absolute;
            top: 0.5vh;
            left: 1.5vw;
            padding: 3vh 0 0 0.5vw;

            .title {
                width: 100%;
                height: 5vh;

                .icon {
                    float: left;
                    width: 2.6vw;
                    height: 5.3vh;
                    background-image: url('../../../assets/img/lutaidalou.png');
                    background-size: 100% 100%;
                    position: relative;
                }

                .icright{
                    float: left;
                    height: 5.3vh;

                    .name {
                        font-size: 26rem;
                        color: #E6F3FD;
                        margin-left: 0.5vw;
                        font-weight: bold;
                    }

                    .area {
                        font-size: 15rem;
                        color:  #E6F3FD;
                        margin-left: 0.5vw;
                    }
                }
            }

            .address {
                font-size:15rem;
                color: rgba(230,243,253, 0.5);
                padding: 1vh 0;
                height: 3.6vh;
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .dataItemContainer {
                width: 100%;
                height:6.5vh;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                padding-top: 1vh;
                border-top: 1px solid rgba(255, 255, 255, 0.3) ;
                position: relative;

                .dataItem {
                    width: 33%;
                    height: 6.5vh;
                    text-align: center;
                    padding-top: 1vh;
                    
                    .data_title {
                        font-size: 1.4vh;
                        color: rgba(230,243,253, 0.7);
                    }

                    .data_value {
                        font-size: 24rem;
                        font-family: zcoolqingkehuangyouti;
                        color: #00DEFF;
                        white-space: nowrap;
                        padding-top: 1vh;
                        font-weight: 400;
                        &>span{
                            display: inline-block;
                            font-size: 14rem;
                        }
                    }
                }
            }
            .dataItemContainer::before{
                content: '';
                width: 1px;
                height: 1px;
                border: 1px solid rgba(255, 255, 255, 0.5);
                border-radius: 50%;
                position: absolute;
                top: -2px;
                left: -1.5px;
            }

            .dataItemContainer::after{
                content: '';
                width: 1px;
                height: 1px;
                border: 1px solid rgba(255, 255, 255, 0.5);
                border-radius: 50%;
                position: absolute;
                top: -2px;
                right:-1.5px; 
            }
        }
    }
}
</style>